import { clearStore } from "@faro-lotv/project-source";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/** Navigation state of the active wizard mode */
export type WizardState = {
  /** Keys of the steps of the active wizard, in order */
  stepKeys: string[];

  /** Index of the step the user is on */
  activeStepIndex: number;

  /** Index of the furthest step the user has reached, all steps up to it can be revisited */
  furthestStepIndex: number;
};

export const WIZARD_INITIAL_STATE: WizardState = {
  stepKeys: [],
  activeStepIndex: 0,
  furthestStepIndex: 0,
};

const wizardSlice = createSlice({
  name: "wizard",
  initialState: WIZARD_INITIAL_STATE,
  reducers: {
    startWizard(_, action: PayloadAction<string[]>) {
      return { ...WIZARD_INITIAL_STATE, stepKeys: action.payload };
    },
    goToNextWizardStep(state) {
      if (state.activeStepIndex >= state.stepKeys.length - 1) return;
      state.activeStepIndex++;
      state.furthestStepIndex = Math.max(
        state.furthestStepIndex,
        state.activeStepIndex,
      );
    },
    goToPreviousWizardStep(state) {
      state.activeStepIndex = Math.max(0, state.activeStepIndex - 1);
    },
    goToWizardStep(state, action: PayloadAction<string>) {
      const index = state.stepKeys.indexOf(action.payload);
      if (index >= 0 && index <= state.furthestStepIndex) {
        state.activeStepIndex = index;
      }
    },
    resetWizard() {
      return WIZARD_INITIAL_STATE;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(clearStore, () => WIZARD_INITIAL_STATE);
  },
});

export const wizardReducer = wizardSlice.reducer;

export const {
  startWizard,
  goToNextWizardStep,
  goToPreviousWizardStep,
  goToWizardStep,
  resetWizard,
} = wizardSlice.actions;
